@if(print && filter){
<app-print-filter-data [filter]="filter" />
} @if(data && data.labels?.length){
<app-bar-chart [data]="data" text="Relatório de engajamento" />
}@else {
<div class="empty">
  <p>Não há dados para exibir</p>
</div>
}
